"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AddressAutoComplete = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../helpers");

var _GoogleMapsAutoComplete = _interopRequireDefault(require("../GoogleMapsAutoComplete"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AddressAutoComplete =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(AddressAutoComplete, _PureComponent);

  function AddressAutoComplete(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AddressAutoComplete);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AddressAutoComplete).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focused: false,
      value: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadPlace",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(place) {
        var _this$props, format, options, onSelect, validate, endpoint, response, _ref2, result, error, value;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, format = _this$props.format, options = _this$props.options, onSelect = _this$props.onSelect, validate = _this$props.validate;
                endpoint = _this.constructor.API_ENDPOINT;

                _this.setState({
                  loading: true,
                  error: undefined
                });

                _context.prev = 3;
                _context.next = 6;
                return fetch(_this.getUrl(place), typeof options === 'function' ? options(_objectSpread({
                  endpoint: endpoint
                }, _this.state)) : options);

              case 6:
                response = _context.sent;
                _context.next = 9;
                return response.json();

              case 9:
                _ref2 = _context.sent;
                result = _ref2.result;

                if (!(validate && (error = validate(result, (0, _helpers.filterComponentName)(result.address_components))))) {
                  _context.next = 13;
                  break;
                }

                throw new Error(error);

              case 13:
                value = format(place, result);

                _this.setState({
                  value: value,
                  focused: false
                }, function () {
                  if (onSelect) onSelect(place, result, value);
                });

                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);

                _this.setState({
                  error: _context.t0,
                  focused: true
                });

              case 20:
                _context.prev = 20;

                _this.setState({
                  loading: false
                });

                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 17, 20, 23]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "blur", function () {
      return _this.setState({
        focused: false
      }, _this.props.onBlur);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
      return _this.setState({
        focused: true
      }, _this.props.onFocus);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeText",
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(value) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.isControlled) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", _this.props.onChangeText(value));

              case 4:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  return _this.setState({
                    value: value,
                    focused: true
                  }, resolve);
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectPlace",
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(place) {
        var _place$structured_for, _place$structured_for2, street, streetNumber, placeholder;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _place$structured_for = place.structured_formatting.main_text.split(','), _place$structured_for2 = (0, _slicedToArray2["default"])(_place$structured_for, 2), street = _place$structured_for2[0], streetNumber = _place$structured_for2[1];

                if (streetNumber) {
                  _context3.next = 8;
                  break;
                }

                placeholder = 'número';
                _context3.next = 5;
                return _this.changeText("".concat(street, ", ").concat(placeholder));

              case 5:
                setTimeout(function () {
                  if (!_this.props.inputRef.current) return;
                  var start = street.length + 2;

                  _this.props.inputRef.current.setSelectionRange(start, start + placeholder.length);

                  _this.props.inputRef.current.focus();
                }, 0);
                _context3.next = 9;
                break;

              case 8:
                _this.loadPlace(place);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    }());

    if (props.initialValue) {
      _this.state.value = props.initialValue;
    }

    return _this;
  }

  (0, _createClass2["default"])(AddressAutoComplete, [{
    key: "getUrl",
    value: function getUrl(place) {
      var apiUrl = this.props.apiUrl;
      var endpoint = this.constructor.API_ENDPOINT;
      var queryString = "q=".concat(place.place_id);
      if (typeof apiUrl === 'function') return apiUrl(_objectSpread({
        endpoint: endpoint,
        place: place,
        queryString: queryString
      }, this.state));else return "".concat(apiUrl, "/").concat(endpoint, "?").concat(queryString);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoCompleteRef = _this$props2.autoCompleteRef,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["autoCompleteRef"]);
      var _this$state = this.state,
          focused = _this$state.focused,
          value = _this$state.value,
          error = _this$state.error;
      return _react["default"].createElement(_GoogleMapsAutoComplete["default"], (0, _extends2["default"])({}, props, {
        ref: autoCompleteRef,
        error: error,
        value: value,
        focused: focused,
        onFocus: this.focus,
        onBlur: this.blur,
        onChangeText: this.changeText,
        onSelect: this.selectPlace
      }));
    }
  }, {
    key: "isControlled",
    get: function get() {
      return typeof this.props.value !== 'undefined' && Boolean(this.props.onChangeText);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        focused: typeof props.focused !== 'undefined' ? props.focused : state.focused,
        value: props.value || state.value
      };
    }
  }]);
  return AddressAutoComplete;
}(_react.PureComponent);

exports.AddressAutoComplete = AddressAutoComplete;
(0, _defineProperty2["default"])(AddressAutoComplete, "API_ENDPOINT", 'details');
(0, _defineProperty2["default"])(AddressAutoComplete, "defaultProps", {
  apiUrl: '/maps',
  format: function format(_ref5) {
    var structured_formatting = _ref5.structured_formatting;
    return structured_formatting.main_text + ' - ' + structured_formatting.secondary_text;
  },

  get inputRef() {
    return _react["default"].createRef();
  }

});

var _default = _react["default"].forwardRef(function (props, ref) {
  return _react["default"].createElement(AddressAutoComplete, (0, _extends2["default"])({
    autoCompleteRef: ref
  }, props));
});

exports["default"] = _default;